import $ from "jquery";

/**
 * $.cookie(name) - Gets cookie value, or undefined;
 * $.cookie(name, value[, options/expire, path, domain, secure]) - Sets the cookie;
 * $.cookie(name, null) - Clears the cookie;
 * 
 * @param {string} name
 * @param {string?|null} value
 * @param {Date|number|null} expires
 * @param {string?} path
 * @param {string?} domain
 * @param {boolean?} secure
 * @returns string
 */

function cookie(name, value, expires, path, domain, secure) {
	if(arguments.length == 1) {
		var args = document.cookie.split(';');
		for(var i = 0; i < args.length; i++) {
			var arg = args[i].split('=');
			if(arg.length == 2) {
				if(name == decodeURIComponent(arg[0]).trim())
					return decodeURIComponent(arg[1]);
			}
		}
	}
	else {
		if(value == null) { value = ""; expires = -1; }
		// this is an object with settings.
		if(expires != null && typeof expires == "object" && !(expires instanceof Date)) {
			path = expires.path;
			domain = expires.domain;
			secure = expires.secure;
			expires = expires.expires;
		}
		var ck = [];
		ck.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
		if(expires != null) {
			if(typeof expires == "number") {
				var seconds = expires;
				expires = new Date();
				expires.setSeconds(expires.getSeconds() + seconds);
			}
			ck.push("expires=" + expires.toUTCString());
		}
		if(path)
			ck.push("path=" + path);
		if(domain)
			ck.push("domain=" + domain);
		if(secure)
			ck.push("secure");
		document.cookie = ck.join(";");
	}
}

$.cookie = cookie;